import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
export function Button({
  children,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const scrollToCTA = () => {
    const ctaSection = document.getElementById('final-cta');
    if (ctaSection) {
      ctaSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    if (onClick) {
      onClick();
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={scrollToCTA} className={`bg-brand-orange hover:bg-orange-600 text-white font-display text-lg md:text-xl uppercase tracking-wider py-4 px-8 rounded-lg shadow-[0_0_20px_rgba(255,107,26,0.3)] transition-colors duration-300 w-full md:w-auto ${className}`} {...props} data-id="element-28">
      {children}
    </motion.button>;
}